import React, { ReactNode, Suspense } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NotFound = React.lazy(() => import('./notFound.svg?react'));

export default function NotFoundPanel({
  title,
  content,
}: {
  title?: string;
  content?: ReactNode;
}) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 0 auto',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: '32px',
          fontWeight: 400,
          textTransform: 'uppercase',
        }}
      >
        {title ?? t('not-found.title')}
      </Typography>
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
      {content}
    </Box>
  );
}
